import { render, staticRenderFns } from "./PersonalAccessHistory.vue?vue&type=template&id=c6de2a52&"
import script from "./PersonalAccessHistory.vue?vue&type=script&lang=ts&"
export * from "./PersonalAccessHistory.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports